import React, { useState } from 'react';

const ShareButtons = ({ title, articleId, compact = false }) => {
  const [copied, setCopied] = useState(false);

  const shareUrl = `https://weeklydefense.com/article/${articleId}/`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const handleNativeShare = async (e) => {
    e.stopPropagation();
    if (navigator.share) {
      try {
        await navigator.share({ title, url: shareUrl });
      } catch (_) {}
    }
  };

  const handleCopy = async (e) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const platforms = [
    {
      name: 'X',
      label: 'X',
      url: `https://x.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      color: '#000000',
    },
    {
      name: 'Reddit',
      label: 'Reddit',
      url: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`,
      color: '#FF4500',
    },
    {
      name: 'WhatsApp',
      label: 'WhatsApp',
      url: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      color: '#25D366',
    },
    {
      name: 'Telegram',
      label: 'Telegram',
      url: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
      color: '#229ED9',
    },
    {
      name: 'LinkedIn',
      label: 'LinkedIn',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: '#0A66C2',
    },
  ];

  // On mobile: use native share sheet (one button)
  if (navigator.share && compact) {
    return (
      <button className="share-native-btn" onClick={handleNativeShare} title="Share">
        <ShareIcon /> Share
      </button>
    );
  }

  return (
    <div className={`share-buttons ${compact ? 'share-compact' : ''}`} onClick={e => e.stopPropagation()}>
      {/* Native share on mobile (non-compact context) */}
      {navigator.share && (
        <button className="share-btn share-native" onClick={handleNativeShare} title="Share">
          <ShareIcon />
        </button>
      )}

      {/* Static platform links */}
     {platforms.map(p => (
        <a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            className="share-btn"
            style={{ '--share-color': p.color }}
            title={`Share on ${p.name}`}
            onClick={e => e.stopPropagation()}
        >
        {p.label}
        </a>
        ))}

      {/* Copy link */}
      <button className="share-btn share-copy" onClick={handleCopy} title="Copy link">
        {copied ? '✓ Copied' : '🔗 Copy'}
      </button>
    </div>
  );
};

const ShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

export default ShareButtons;